// @note needs to be synced with the backend function
// PaymentStatusEnum
/*
 * Mollie payment status:
 * open
 * canceled
 * pending
 * authorized //not possible in iDeal
 * expired
 * failed
 * paid
 */

const paymentStatusEnum = [
  {
    label:'Te betalen',
    labelOutgoing: 'Te ontvangen',
    value: 'open',
  },
  {
    label:'Geannuleerd',
    labelOutgoing:'Geannuleerd',
    value: 'canceled',
  },
  {
    label:'Betaling bezig',
    labelOutgoing: 'Betaling bezig',
    value: 'pending',
  },
  {
    label:'Te betalen, geautoriseerd',
    labelOutgoing:'Te ontvangen, geautoriseerd',
    value: 'authorized',
  },
  {
    label:'Verlopen',
    labelOutgoing:'Verlopen',
    value: 'expired',
  },
  {
    label:'Mislukt',
    labelOutgoing:'Mislukt',
    value: 'failed',
  },
  {
    label:'Betaald',
    labelOutgoing:'Uitbetaald',
    value: 'paid',
  },
];

export default paymentStatusEnum
